import React from 'react';

const CardHeader = ({className, children}) => {
    return (
        <div className={["bg-gray-200 py-[5px] px-[10px] rounded-t-[0.5rem] border-b border-gray-300 flex justify-start items-center", className].join(" ")}>
            {children}
        </div>
    );
};

export default CardHeader;